import { useEffect, useMemo, useRef, useState } from 'react';
import s from './Modules.module.scss';
import { DropdownBlock } from 'components/DropdownBlock/DropdownBlock';
import { ReactComponent as Arrow } from "../../../../../../assets/icons/arrow_tools.svg";
import { AddCourseModule } from './component/AddCourseModule/AddCourseModule';
import { useSelector } from 'react-redux';
import { AddCourseLesson } from './component/AddCourseLesson/AddCourseLesson';
import ImageIcon from "../../../../../../assets/icons/image.svg"
import { useTranslation } from 'react-i18next';
import { ImageInput } from 'components/ImageInput/ImageInput';
import { clearHTML } from 'utils/clearHTML';


export const Modules = ({form, setForm, dropdown, setDropDown, setActiveLang, activeLang, setDeletedLessons, setDeletedModules}: any) => {

    // ### State
    const [modules, setModules] = useState<{[val: string]: boolean}>({})
    const [mode, setMode] = useState<string>("module")
    const [currentModule, setCurrentModule] = useState<any>(false)
    const [currentLesson, setCurrentLesson] = useState<any>(false)
    const [module, setModule] = useState<any>({
        image: undefined,
        name: undefined,
        description: undefined
    })

    const langs = useSelector((store: any) => store.main.langs);
    const {t} = useTranslation()

    const initialModuleState = {
        new: true,
        image: undefined,
        name: langs?.reduce((acc: any, lang: any) => {
            acc[lang.key] = ""
            return acc
        }, {}),
        description: langs?.reduce((acc: any, lang: any) => {
            acc[lang.key] = ""
            return acc
        }, {}),
    }

    // ### Effects
    useEffect(()=>{
        setCurrentModule(form?.modules?.[0])
    },[]);

    useEffect(()=>{
        if(currentModule?.id) setModule(currentModule)
            else setModule(initialModuleState)
    },[currentModule]);

    useEffect(()=>{
        form.modules.forEach((module: any) => {
            setModules((prev: any) => {
                return {...prev, [module.id]: prev[module.id] || false}
            })
        })
        if(!currentModule) setCurrentModule(form?.modules?.[0])
    },[form.modules]);

    

    // ### Functions
    function changeCurrentModule(module: any){
        setMode("module")
        setCurrentModule(module)
    }

    function changeCurrentLesson(lesson: any){
        setMode("lesson")
        setCurrentLesson(lesson)
    }

    function addModule(module: any){
        const now = Number(new Date().getTime().toString().slice(-5))
        
        setForm((prev: any) => {
            const isset = form.modules.find((mod:any) => mod.id === module.id)
            
            if(!isset){
                setCurrentModule({
                    ...module,
                    id: now
                })
                return {
                    ...prev,
                    modules: [
                        ...prev.modules,
                        {
                            id: now,
                            new: module.new,
                            name: module.name,
                            description: module.description,
                            image: module.image
                        }
                    ]
                }
            }
            else{
                const currentIndex = form.modules.indexOf(isset)
                prev.modules[currentIndex] = module
                return {
                    ...prev,
                    modules: prev.modules
                }
            }
        })
    }

    // ### Views
    const modulesView = form?.modules?.map((module: any) => {
        return(
            <div key={module.id} className={`${s.module} ${module?.id === currentModule?.id ? s.active_module : ""}`}>
                <div className={s.module_header}>
                    <div className={s.image_wrapper} onClick={() => changeCurrentModule(module)}>
                        <ImageInput 
                            values={module.image}
                            disabled={true}
                        />
                    </div>
                    <div  className={s.name_wrapper} onClick={() => changeCurrentModule(module)}>
                        <p className={s.name}>{clearHTML(module?.name?.[activeLang] || t('courses.new_module'))}</p>
                    </div>
                    <div 
                        className={`${s.arrow_wrapper} ${modules[module.id] ? s.active_arrow : ''}`}
                        onClick={()=>{
                            setModules((prev: any) => {
                                return {...prev, [module?.id]: !prev[module?.id]}
                            })
                        }}
                    >
                        <Arrow />
                    </div>
                </div>
                <DropdownBlock open={modules?.[module.id as string]}>
                    <div className={s.lessons_wrapper}>
                    {
                        module.lessons?.map((lesson: any) => {
                            return(
                                <div 
                                    key={lesson.id}
                                    className={`${s.lesson} ${currentLesson?.id === lesson.id ? s.active_lesson : ""}`} 
                                    onClick={() => {
                                        changeCurrentLesson(lesson)
                                        setCurrentModule(module)
                                    }}
                                >
                                    <span>{clearHTML(lesson.name[activeLang] || t('courses.new_lesson'))}</span>
                                </div>
                            )
                        })
                    }
                    </div>
                </DropdownBlock>
            </div>
        )
    })
    
    return(
        <div className={s.wrapper}>
            <div className={`${s.header} ${dropdown?.module ? s.active : ""}`} onClick={() => setDropDown((prev: any) => ({...prev, module: !prev.module}))}>
                <div className={`${s.arrow}`} ><Arrow/></div>
                <p className={s.title}>{t('courses.modules')}</p>
            </div>
            <DropdownBlock open={dropdown.module}>
                {
                !form?.modules?.length ?
                <div className={s.add_budton} onClick={() => {addModule(initialModuleState); setMode("module");}}>{t('courses.add_module')}</div> :
                <div className={s.wrapper}>
                    <div className={s.left}>
                        {modulesView}
                        <div className={s.add_budton} onClick={() => {addModule(initialModuleState); setMode("module");}}>{t('courses.add_module')}</div>
                    </div>
                    <div className={s.right}>
                        {
                            currentModule && mode === "module" ? 
                            <AddCourseModule 
                                data={currentModule} 
                                setActiveLang={setActiveLang} 
                                activeLang={activeLang}
                                form={form}
                                setForm={setForm}
                                setCurrentModule={setCurrentModule}
                                currentModule={currentModule}
                                addModule={addModule}
                                module={module}
                                setModule={setModule}
                                setMode={setMode}
                                setCurrentLesson={setCurrentLesson}
                                setModules={setModules}
                                setDeletedModules={setDeletedModules}
                            /> : null
                        }
                        {
                            currentLesson && mode === "lesson" ? 
                            <AddCourseLesson 
                                data={currentLesson} 
                                form={form}
                                setForm={setForm}
                                currentModule={currentModule}
                                setCurrentLesson={setCurrentLesson}
                                setActiveLang={setActiveLang} 
                                activeLang={activeLang}
                                setDeletedLessons={setDeletedLessons}
                            /> : null
                        }
                    </div>
                </div>
                }
                
            </DropdownBlock>

        </div>
    )
}